import { useQuery } from "@tanstack/react-query";
import { getCoachReviewBundle } from "@/lib/api";
import { useScopedKey } from "@/lib/queryClient";

/**
 * Coach Review bundle hook — keyed on scope + the three optional
 * search params (`match_id`, `note_id`, `clip_id`) so the cache
 * splits cleanly per edit context.
 *
 * Use this from the route component, not from individual sub-
 * components — the bundle is a single coalesced fetch and the
 * children read from it via context or props.
 */
export function useCoachReviewBundle(input: {
  matchId?: string;
  noteId?: number;
  clipId?: number;
}) {
  return useQuery({
    queryKey: useScopedKey("coach-review-bundle", {
      match_id: input.matchId ?? null,
      note_id: input.noteId ?? null,
      clip_id: input.clipId ?? null,
    }),
    queryFn: () => getCoachReviewBundle(input),
    // Coach Review's bundle changes when the coach saves a note/clip
    // (mutations invalidate via `invalidateScope()`), but otherwise
    // the data is mostly static — keep it cached for 30s on top of
    // the global default.
    staleTime: 30_000,
  });
}
